// Base URLS and Configuration
import { danielleLogo, danielleSidebarLogo } from "src/assets";
import { _get_consultant_from_localStorage } from "src/DAL/localstorage/LocalStorage";
import { update_root_value } from "src/utils/domUtils";

export const project_name = process.env.REACT_APP_PROJECT_NAME;
const get_consultant = _get_consultant_from_localStorage();

// Base URLS
export const baseUri = process.env.REACT_APP_API_BASE_URL;
export const s3baseUrl = process.env.REACT_APP_PIC_BASE_URL;
export const websiteUrl = process.env.REACT_APP_WEBSITE_URL;

export const material_theme_palate = {
  lighter: "#d4bff2",
  light: "#ede7f6",
  main: "#C19D60",
  dark: "#198BA8",
  darker: "#198BA8",
  contrastText: "#fff",
};

export const OwnerName = () => {
  return "Danielle";
};

export const ownerName = OwnerName() + "'s";
export const ownerCompleteName = OwnerName();

export const get_app_logo = () => {
  return get_consultant?.brand_logo;
};

export const get_app_headers = () => {
  return {
    title: get_consultant?.meta_title,
    description: get_consultant?.meta_description,
    fav_icon: get_consultant?.brand_favicon,
  };
};

// DANIELLE Theme Configuration
material_theme_palate.main = "#C19D60";
/* Main theme color */
update_root_value("--portal-theme-primary", "#C19D60");
update_root_value("--portal-theme-secondary", "rgb(255 218 0 / 8%)");
update_root_value("--text-primary-color", "white");
update_root_value("--text-secondary-color", "rgb(150, 150, 150)");
/* Main theme color end */

/* Main background color*/
update_root_value("--background-primary-color", "black");
update_root_value("--background-secondary-color", "#1d1c1d");
/* Main background color end*/

/* Sidebar Properties */
update_root_value("--sidebars-text-color", "white");
update_root_value("--sidebars-active-color", "#C19D60");
update_root_value("--sidebars-hover-color", "#C19D60");
update_root_value("--sidebars-background-color", "#1d1c1d");
/* Sidebar Properties */

/* Popup / Popover properties  */
update_root_value("--popup-background-color", "#1d1c1d");
update_root_value("--popup-text-color", "white");
/* Popup / Popover properties end  */

/* Element properties */
update_root_value("--input-text-color", "#fff");
update_root_value("--input-placeholder-color", "#fff");
update_root_value("--input-background-primary", "#1d1c1d");
update_root_value("--input-background-secondary", "#1d1c1d");
update_root_value(" --icons-color-allover", "#C19D60");
/* Element properties ends*/

/* Button Properties */
update_root_value("--button-background-color", "#1c1c1c");
update_root_value("--button-text-color", "#C19D60");
update_root_value("--button-outlined-color", "#C19D60");
update_root_value("--button-hover-color", "#C19D60");
/* Button Properties ends*/

/* Audio Properties */
update_root_value("--audio-color", "rgb(56, 54, 54)");
/* Audio Properties ends*/

/* calendar Properties */
update_root_value("--calendar-selected-box", "#8b8b8b");
/* calendar Properties ends*/
